import Dynamic from '@base/Dynamic/Dynamic';
import Description from './Description/Description';
import Syllabus from './Syllabus';
import useLanding from './useLanding';

const Modals = Dynamic(() => import('./Modals'));

const TestDetails = () => {
  const { loading } = useLanding();

  return (
    <>
      <Description loading={loading} />
      <Syllabus />
      <Modals />
    </>
  );
};

export default TestDetails;
